export const COMPONENT_NAME = 'TicketBookingForm';
